import React from 'react';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { FeaturesSection } from './components/FeaturesSection';
import { HowItWorks } from './components/HowItWorks';
import { CtaBanner } from './components/CtaBanner';
import { SeoContentSection } from './components/SeoContentSection';
import { Footer } from './components/Footer';
import { FriendLinks } from './components/FriendLinks';
export function App() {
  return <div className="min-h-screen bg-dark-bg text-white selection:bg-pink-primary/30 selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <AboutSection data-id="element-2" />
      <ServicesSection data-id="element-3" />
      <FeaturesSection data-id="element-4" />
      <HowItWorks data-id="element-5" />
      <SeoContentSection data-id="element-6" />
      <FriendLinks data-id="element-7" />
      <CtaBanner data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}